import { AuroraTheme } from '@careem-public/aurora-antd/build/index';

export const {
  token: {
    colorBgBase,
    colorPrimary,
    colorWhite,
    colorInfoBg,
    colorInfoBorder,
    colorTextSecondary,
    colorWarning,
    colorWarningBg,
    colorWarningBorder,
    colorErrorBorder,
    colorSuccessBg,
    colorSuccessActive,
    colorError,
    colorErrorBg,
    colorTextBase,
    colorBgContainer,
    colorIcon,
    colorBorder,
    colorFill,
    colorTextDisabled
  }
} = AuroraTheme;

export const primaryColor = colorPrimary;
export const whiteColor = colorWhite;
export const black = colorBgBase;
export const secondaryText = colorTextSecondary;
export const warningBorderColor = colorWarningBorder;
export const yellow200Color = colorWarningBorder;
const fontSizeIcon = 12;
export const alertInfoBgColor = colorInfoBg;
export const alertInfoBorderColor = colorInfoBorder;

export const mainExpressTheme = {
  token: {
    ...AuroraTheme.token,
    fontFamily: 'Inter, sans-serif',
    fontSize: 14,
    fontSizeLG: 16,
    fontSizeXL: 20,
    fontSizeSM: 12,
    fontSizeHeading1: 32,
    fontSizeHeading2: 24,
    fontSizeHeading3: 20,
    fontSizeHeading4: 16,
    fontSizeIcon,
    borderRadius: 4
  },
  components: AuroraTheme.components
};
